import reduce from 'lodash/reduce';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import find from 'lodash/find';

export const convertPolygonToGEOJSONFormat = (coordinates) => {
  return [
    reduce(
      coordinates,
      (result, coord) => [...result, [ coord.lng, coord.lat ]],
      []
    )
  ];
}
export const convertPointToGEOJSONFormat = (coordinates) => {
  return [ coordinates[0].lng, coordinates[0].lat ];
}

export const metersToPixels = (meters, latitude) => {
  return meters / 0.075 / Math.cos(latitude * Math.PI / 180);
}
export const createSourceConfig = (geometry, properties = {}) => ({
  type: "geojson",
  data: {
    type: "FeatureCollection",
    features: [{
      type: "Feature",
      geometry,
      properties
    }],
  }
});

export const createDropoffSourceConfig = (features) => ({
  type: "geojson",
  data: {
    type: "FeatureCollection",
    features
  }
});

export const createGeometryConfig = (type, coordinates) => ({
  type,
  coordinates
});
export const createFeatureConfig = (geometry) => ({
  "type": "Feature",
  "properties": {},
  "geometry": geometry
});
export const createPolyLayerConfig = (source) => ({
  id: `${source}`,
  type: "fill",
  source: source,
  paint: {
    'fill-color': '#F25F23',
    'fill-opacity': 0.35
  }
});
export const createPlaceLayerConfig = (source) => ({
  id: `${source}`,
  type: "fill",
  source: source,
  paint: {
    'fill-color': '#F25F23',
    'fill-opacity': 0.35
  }
});
export const createPointLayerConfig = (source, meters, lat) => ({
  id: `${source}`,
  type: "circle",
  source: source,
  paint: {
    'circle-radius': {
      stops: [
        [0, 0],
        [20, metersToPixels(meters, lat)]
      ],
      base: 2
    },
    'circle-color': "#F25F23",
    'circle-opacity': 0.35
  }
});
export const createDropoffLayerConfig = (source) => ({
  id: `${source}`,
  type: "circle",
  source: source,
  paint: {
    'circle-radius': 5,
    'circle-color': "#FFFFFF",
    'circle-opacity': 0,
    'circle-stroke-width': 3,
    'circle-stroke-color': "#F25F23",
    'circle-stroke-opacity': 1
  }
});

export const getCoordinates = (location) => (!isEmpty(location) ?
    [ get(location, 'lng'), get(location, 'lat') ] : []);

export const isLocationEqual = (prevLoc, nextLoc) => {
  const prevCoords = getCoordinates(prevLoc);
  const nextCoords = getCoordinates(nextLoc);
  return isEqual(prevCoords, nextCoords);
};

export const getSelectedDropoffCoordinates = (currentPlace, selection) => {
  const selectedId = get(selection, 'value', '')
  const dropoffPoints = get(currentPlace, 'dropoff_locations', [])
  const selectedLoc = find(dropoffPoints, ({id}) => id === selectedId);
  return get(selectedLoc, 'point.coordinates');
}
